// extracted by mini-css-extract-plugin
export var addToCartButton = "_u5-b";
export var arrowButtonContainer = "_u5-9";
export var arrowButtonIcon = "_u5-a";
export var carouselArrowButton = "_u5-6";
export var carouselElementContainer = "_u5-1";
export var left = "_u5-7";
export var productDisplayCarouselContainer = "_u5-0";
export var productTileContainer = "_u5-2";
export var productTileImage = "_u5-4";
export var productTileImageContainer = "_u5-3";
export var productTileTitle = "_u5-5";
export var right = "_u5-8";
export var sliderOverflow = "_u5-c";